var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVisa(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 250,
    height: 82,
    viewBox: "0 0 250 82",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_934_8287)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M108.333 80.8169H88.0813L100.748 1.43872H120.999L108.333 80.8169Z",
    fill: "#00579F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.748 3.37944C177.753 1.77334 171.417 0 163.583 0C143.584 0 129.501 10.8084 129.414 26.2611C129.248 37.6621 139.498 43.9945 147.163 47.7959C154.998 51.6804 157.662 54.2159 157.662 57.6784C157.582 62.9961 151.331 65.4474 145.5 65.4474C137.414 65.4474 133.082 64.1836 126.498 61.225L123.832 59.9568L120.998 77.7755C125.748 79.9686 134.499 81.9147 143.584 82C164.834 82 178.668 71.3589 178.832 54.8915C178.912 45.8554 173.5 38.9315 161.832 33.2737C154.749 29.6417 150.411 27.1927 150.411 23.4765C150.494 20.0982 154.08 16.6379 162.076 16.6379C168.66 16.4685 173.497 18.0723 177.162 19.6773L178.993 20.5202L181.748 3.37944Z",
    fill: "#00579F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.664 52.696C210.332 48.1359 216.749 30.4867 216.749 30.4867C216.665 30.6561 218.414 25.8423 219.414 22.8871L220.829 29.7268C220.829 29.7268 224.664 48.7273 225.497 52.696C222.332 52.696 212.664 52.696 208.664 52.696ZM233.662 1.43872H217.997C213.167 1.43872 209.497 2.8731 207.412 8.02476L177.331 80.8158H198.581C198.581 80.8158 202.079 71.0186 202.831 68.9086C205.162 68.9086 225.834 68.9086 228.833 68.9086C229.414 71.6954 231.249 80.8158 231.249 80.8158H250L233.662 1.43872Z",
    fill: "#00579F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.1663 1.43872L51.3332 55.567L49.1659 44.5892C45.4992 31.9222 33.9995 18.1597 21.1665 11.3167L39.3329 80.7327H60.7486L92.5809 1.43872H71.1663Z",
    fill: "#00579F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.9164 1.43872H0.333338L0 3.04258C25.4169 9.62974 42.2499 25.5078 49.1659 44.5925L42.0827 8.11118C40.9166 3.04146 37.3329 1.60595 32.9164 1.43872Z",
    fill: "#FAA61A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_934_8287"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 250,
    height: 82,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisa);
export default __webpack_public_path__ + "static/media/visa.34f32e5b1d532eff6a5fbb662fd2e30a.svg";
export { ForwardRef as ReactComponent };